import type { ActivityType } from "./types";

export const SETUP_ACTIVITY_NAME = "Einrichtung";
export const TABBING_ACTIVITY_NAME = "Tabbern";
export const CORRECTION_ACTIVITY_NAME = "Nacharbeit";
export const LEGACY_CORRECTION_ACTIVITY_NAME = "Korrekturen";
export const FALLBACK_ACTIVITY_NAME = "Sonstiges / nicht zugeordnet";

export function activityNameKey(name: string): string {
  return name.trim().toLocaleLowerCase("de-DE");
}

export function isExcludedJobActivity(name: string): boolean {
  const compact = activityNameKey(name).replace(/[\s_-]+/g, "");
  return compact === "postaufliefern";
}

export function normalizeJobActivityName(name: string): string {
  const key = activityNameKey(name);
  if (key === activityNameKey(LEGACY_CORRECTION_ACTIVITY_NAME)) return CORRECTION_ACTIVITY_NAME;
  if (key === "tabben" || key === activityNameKey(TABBING_ACTIVITY_NAME)) return TABBING_ACTIVITY_NAME;
  return name.trim();
}

export function selectableActivityNames(names: string[], activitiesMissing = false): string[] {
  const source = activitiesMissing || names.length === 0 ? [FALLBACK_ACTIVITY_NAME] : names;
  const reserved = new Set([activityNameKey(SETUP_ACTIVITY_NAME), activityNameKey(CORRECTION_ACTIVITY_NAME), activityNameKey(LEGACY_CORRECTION_ACTIVITY_NAME)]);
  const seen = new Set<string>();
  const middle: string[] = [];

  for (const rawName of source) {
    const name = normalizeJobActivityName(rawName);
    const key = activityNameKey(name);
    if (!name || reserved.has(key) || seen.has(key) || isExcludedJobActivity(name)) continue;
    seen.add(key);
    middle.push(name);
  }

  if (middle.length === 0) {
    middle.push(FALLBACK_ACTIVITY_NAME);
  }

  return [SETUP_ACTIVITY_NAME, ...middle, CORRECTION_ACTIVITY_NAME];
}

export function selectableActivitiesForOrder(
  order: { production_activities_json: string[]; activities_missing?: boolean } | undefined,
  activities: ActivityType[]
): ActivityType[] {
  if (!order) return activities.filter((activity) => !isExcludedJobActivity(activity.name));
  const activityByName = new Map(activities.map((activity) => [activityNameKey(activity.name), activity]));
  const selected = selectableActivityNames(order.production_activities_json ?? [], Boolean(order.activities_missing))
    .map((name) => activityByName.get(activityNameKey(name)))
    .filter((activity): activity is ActivityType => Boolean(activity));
  return selected.length ? selected : activities.filter((activity) => activityNameKey(activity.name) === activityNameKey(FALLBACK_ACTIVITY_NAME));
}
